function LeftPopup() {
    return(
        <>
            <img src={"Talking Head 2.png"} className={"popup-left"}></img>
        </>
    )
}

export default LeftPopup